import { useEffect, useState } from 'react';
import { operatorService } from '../../services/operator.service';
import type { Operator } from '../../types/crm';
import { toast } from '../../hooks/useToast';
import { getErrorMessage } from '../../lib/api';
import ContactList from '../../components/crm/ContactList';

// Flat /crm/contacts page. The shared `ContactList` does the heavy lifting; this
// page adds an operator filter on top so the same component renders unfiltered
// here and operator-scoped inside `OperatorDetail`.
export const Contacts = () => {
  const [operators, setOperators] = useState<Operator[]>([]);
  const [operatorFilter, setOperatorFilter] = useState<number | undefined>(undefined);

  useEffect(() => {
    operatorService
      .getAll({ per_page: 100 })
      .then((res) => setOperators(res.data))
      .catch((err) => toast.error(getErrorMessage(err)));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Contacts</h1>
        <p className="text-sm text-gray-600 mt-1">All contacts across your operator accounts.</p>
      </div>

      <div className="card p-4 flex flex-wrap gap-3 items-end">
        <div>
          <label className="label">Filter by operator</label>
          <select
            value={operatorFilter ?? ''}
            onChange={(e) => setOperatorFilter(e.target.value ? Number(e.target.value) : undefined)}
            className="input"
          >
            <option value="">All operators</option>
            {operators.map((op) => (
              <option key={op.id} value={op.id}>{op.name}</option>
            ))}
          </select>
        </div>
      </div>

      <ContactList operatorId={operatorFilter} />
    </div>
  );
};

export default Contacts;
